import { cn } from "@/utils";

export const FreshenerOneView = ({
  item,
  onClick,
  size = "large",
}: {
  item: {
    design: { front_proof: string; back_proof: string };
  };
  onClick: () => void;
  size: "small" | "large";
}) => {
  const sizeClasses = size === "small" ? "h-10 w-10 lg:h-10 lg:w-10" : "";
  return (
    <div className="relative my-auto">
      {item.design.front_proof ? (
        <img
          src={item.design.front_proof}
          className={cn(
            "w-[50px] max-h-[70px] lg:w-[140px] lg:max-h-[188px] cursor-pointer rounded-md object-contain max-w-[unset]",
            sizeClasses
          )}
          onClick={onClick}
        />
      ) : (
        <div
          className={cn(
            "w-[50px] h-[70px] lg:w-[140px] lg:h-[180px] rounded-md bg-gray-300",
            sizeClasses
          )}
        />
      )}
      {size !== "small" && (
        <>
          {item.design.back_proof ? (
            <img
              src={item.design.back_proof}
              className={cn(
                "w-[40px] cursor-pointer rounded-md object-contain max-w-[unset] absolute -top-3 -left-2 png-drop-shadow-sm hidden lg:block"
              )}
              onClick={onClick}
            />
          ) : (
            <div className="w-[40px] h-[60px] rounded-md bg-gray-300 border border-gray-400 hidden lg:block absolute -top-3 -left-2" />
          )}
        </>
      )}
    </div>
  );
};
